import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import { OrderPayload } from 'pages/user-preferences/store';
import { CssTextField } from 'components/select';

const DelegateTitle = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);

    const handleChange = (event) => {
        setOrder({
            ...order,
            delegateTitle: event.target.value,
        });
    };

    const validateInput = () => {
        if ((isTouched && order?.isTouched && !order?.delegateTitle) || isTouched) {
            return 'validate';
        }
        return '';
    };

    React.useEffect(() => {
        if (!order?.delegateTitle && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.delegateTitle, order?.isTouched]);

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <CssTextField
                size="small"
                label="Title *"
                value={order?.delegateTitle || ''}
                onChange={handleChange}
                className={validateInput()}
                fullWidth
                data-testid="delegate-title"
                placeholder="Enter delegate title"
            />
        </Box>
    );
};

export default React.memo(DelegateTitle);
